import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import AuthGuard from './components/Auth/AuthGuard';
import LoginForm from './components/Auth/LoginForm';
import MainLayout from './components/Layout/MainLayout';
import Dashboard from './pages/Dashboard';
import Schedules from './pages/Schedules';
import Settings from './pages/Settings';
import Reports from './pages/Reports';
import DocumentTransmittals from './pages/DocumentTransmittals';
import PendingReports from './pages/PendingReports';
import FeesManagement from './pages/FeesManagement';
import TherapistList from './components/Therapists/TherapistList';
import StudentList from './components/Students/StudentList';
import StudentSessions from './pages/StudentSessions';
import GuestStudents from './pages/GuestStudents';
import UserManagement from './pages/UserManagement';
import Invoice from './pages/Invoice';
import Backup from './pages/Backup';
import Accounting from './pages/Accounting';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppProvider>
          <Router>
            <div className="App">
              <Routes>
                <Route 
                  path="/login" 
                  element={
                    <AuthGuard requireAuth={false}>
                      <LoginForm onLoginSuccess={() => window.location.href = '/'} />
                    </AuthGuard>
                  } 
                />
                <Route 
                  path="/*" 
                  element={
                    <AuthGuard>
                      <MainLayout>
                        <Routes>
                          <Route path="/" element={<Dashboard />} />
                          <Route path="/dashboard" element={<Dashboard />} />
                          <Route path="/schedules" element={<Schedules />} />
                          <Route path="/therapists" element={<TherapistList />} />
                          <Route path="/document-transmittals" element={<DocumentTransmittals />} />
                          <Route path="/students" element={<StudentList />} />
                          <Route path="/guest-students" element={<GuestStudents />} />
                          <Route path="/student-sessions" element={<StudentSessions />} />
                          <Route path="/fees-management" element={<FeesManagement />} />
                          <Route path="/accounting" element={<Accounting />} />
                          <Route path="/invoice" element={<Invoice />} />
                          <Route path="/pending-reports" element={<PendingReports />} />
                          <Route path="/reports" element={<Reports />} />
                          <Route path="/settings" element={<Settings />} />
                          <Route path="/users" element={<UserManagement />} />
                          <Route path="/backup" element={<Backup />} />
                          <Route path="*" element={<div>Page Not Found</div>} />
                        </Routes>
                      </MainLayout>
                    </AuthGuard>
                  } 
                />
              </Routes>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </div>
          </Router>
        </AppProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
